import {Injectable} from '@angular/core';
import {HttpApiService} from '../../shared/services/http-api.service';
import {HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ApiResponseModel} from '../../shared/entities/api-response.model';
import {JobTypeModel} from '../models/jobType.model';

@Injectable({
    providedIn: 'root'
})

export class CityService {

    constructor(
        public httpApiService: HttpApiService,
        private router: Router,
    ) {

    }

    getList(countyUid: string = null): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('cities/getList',{countyUid: countyUid});
    }


}


